import * as keyapis_tag_v1_system_pb from "./v1/keyapis_tag_system_v1.pb";
import * as keyapis_tag_v1_tag_pb from "./v1/keyapis_tag_tag_v1.pb";

export default {
  v1: {
    resources: {
      system: keyapis_tag_v1_system_pb,
      tag: keyapis_tag_v1_tag_pb,
    },
  },
};
